<template>
  <div class="main-page">
    <h1 class="page-title">
      同意事項
    </h1>
    <div class="page-content">
      <ul class="list-instructions">
        <li>
          <p class="text-jp">
            以下内容に同意いただけましたら「同意して次へ」を押してください
          </p>
        </li>
      </ul>
      <section class="section-category">
        <h2 class="title-item green">
          <span class="jp">同意事項</span>
        </h2>
        <div class="content">
          <div class="agreements-list">
            <!-- 3 -->
            <p v-if="forms.indexOf(3) != -1">
              《住民票について》<br>
              ■住民票の写し発行には1通300円かかります。<br>
              ■松山市以外の住民票を請求される場合は、窓口職員に申し出てください。<br>
              ■住所の履歴等が必要な場合は窓口職員に申し出てください。<br>
            </p>
            <!-- 4 -->
            <p v-if="forms.indexOf(4) != -1">
              《印鑑登録証明書について》<br>
              ■印鑑登録証のご提示が必要です。<br>
              ■印鑑登録証明書発行には1通300円かかります。<br>
            </p>
            <!-- 5 -->
            <p v-if="forms.indexOf(5) != -1">
              《マイナンバーカードの電子証明書の発行・更新について》<br>
              ■申請書の発行はご本人様分に限ります。<br>
              ■窓口での電子証明書の発行・更新手続きには、マイナンバーカードと暗証番号が必要です。<br>
              ■15歳未満の方又は成年被後見人の方は、原則として利用者証明用電子証明書のみの発行となります。
            </p>
            <p>
              《その他》
              <!-- 2,3 -->
              <span v-if="forms.indexOf(2) != -1 || forms.indexOf(3) != -1">
                <br>
                ■法人が請求する場合は、法人の所在地及び法人名の記入と、法人印（社印）又は代表者の印の押印が必要です。<br>
                ■窓口で、ご本人であることを確認できる書類の提示が必要です。 <br>
                （本人確認書類：免許証、パスポート、保険証、住基カード、マイナンバーカード、年金手帳、学生証、在留カードなど）<br>
                ■代理人様の申請には委任状が必要です。 <br>
                例） <br>
                ・転出/転居届・・・あなた以外が異動される場合 <br>
                ・住民票・・・あなた以外の証明書が必要な場合 <br>
                ※委任状のサンプルは<a
                  href="https://www.city.matsuyama.ehime.jp/smph/kurashi/download/shimin/shiminnbu/ininjo_shoumei_idou.html"
                  target="_blank"
                >こちら</a>をご確認ください。<br>
                ■第三者又は法人等が請求する場合は、請求事由及び利害関係書を証明する書類等（疎明資料）の添付も必要です。
              </span>
              <!-- always -->
              <br>■画面入力後、窓口でのお手続きが必要です。入力後に表示されるQRコードをあなた様ご自身にて窓口へご提示ください。<br>
              ■偽りその他不正な手段によって、交付を受けたときは、法により過料に処せられる又は罰せられます。
            </p>
          </div>
        </div>
      </section>
      <div class="list-button">
        <button
          type="button"
          class="button trans"
          @click="changeRouter('selection')"
        >
          <span class="txt">戻る</span>
        </button>
        <button
          type="button"
          class="button trans"
          @click="changeRouter('form')"
        >
          <span class="txt">同意して次へ</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Agreements',
  data() {
    return {
      forms: []
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.forms = this.$store.state.selection;
  },
  methods: {
    /**
     * Change router
     * @param {string} name - name of router to change
     */
    changeRouter: function (name) {
      this.$router.push({ name: name });
    },
  },
};
</script>